import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Suspense } from "react";
import { SheetSkeleton } from "@/components/skeletons/sheet-skeleton";
import { Button } from "@/components/ui/button";
import { SheetHeader } from "@/components/ui/sheet";
import { TransactionSheet } from "../transactions/-components/transaction-sheet";

export const Route = createFileRoute("/_authed/_org/tax/$id/")({
  component: RouteComponent,
  loader: ({ context: { queryClient, trpc }, params: { id } }) => {
    queryClient.ensureQueryData(
      trpc.transaction.get.queryOptions({
        transactionId: id,
      }),
    );
    queryClient.ensureQueryData(trpc.org.users.queryOptions());
    queryClient.ensureQueryData(trpc.accounting.get.queryOptions());
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { id } = Route.useParams();

  return (
    <>
      <SheetHeader className=" px-2">
        <Button
          className="m-0 h-4 w-16 p-0"
          onClick={() =>
            navigate({
              to: "/tax",
            })
          }
          variant={"text"}
        >
          <ArrowLeft />
          <span>Back</span>
        </Button>
      </SheetHeader>

      <Suspense fallback={<SheetSkeleton />}>
        <TransactionSheet id={id} />
      </Suspense>
    </>
  );
}
